import { Injectable } from '@angular/core';
import { ContactInfo } from '../contact-info';
import { ContactInfoUpdateInsured, ContactInfoUpdateOwner } from '../interfaces/contact-info.interface';
import { AmorphicService } from '../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ContactInfoResponse } from '../../../js/policyAdmin/PolicyAdminClient';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import * as uuid from 'uuid';

@Injectable()
export class ContactInfoService {
  controller;
  contactInfo;
  public insured: ContactInfo;
  public owner: ContactInfo;
  policyId: string;
  policyType: string;
  insuredId: string;
  policyAdminDown: boolean = false;

  useSecondary: boolean;

  constructor(private amorphicService: AmorphicService) {
    this.controller = amorphicService.controller;
  }

  ngOnInit() {}

  setPolicyType(policyType: string) {
    this.policyType = policyType;
  }

  getContactInfoResponse(): ContactInfoResponse {
    this.useSecondary = false;
    if (this.policyType) {
      if (this.policyType === 'Term') {
        this.useSecondary = true;
      }
      return this.controller.getContactInfo(this.useSecondary);
    } else {
      return this.controller.getContactInfo();
    }
  }

  submitUpdateContact(url: string, body: {}) {
    if (this.policyType) {
      return from(this.controller.updatePolicyInfoInPolicyAdmin(url, body, this.useSecondary));
    } else {
      return from(this.controller.updatePolicyInfoInPolicyAdmin(url, body));
    }
  }

  async getContactInfoPA() {
    try {
      const contactInfoResponse = await this.getContactInfoResponse();

      this.contactInfo = contactInfoResponse;
      this.policyId = this.contactInfo.policy.policyId;
    } catch (e) {
      this.policyAdminDown = true;
    }
  }

  async updateContact(contactInfo: ContactInfo, type: string) {
    const line1 = contactInfo.line1 && contactInfo.line1.length !== 0 ? contactInfo.line1 : ' ';
    const line2 = contactInfo.line2 && contactInfo.line2.length !== 0 ? contactInfo.line2 : ' ';
    const update: ContactInfoUpdateInsured | ContactInfoUpdateOwner = {
      partyInfo: {
        phone: {
          number: contactInfo.phoneNumber,
        },
        person: {
          firstName: contactInfo.firstName,
          lastName: contactInfo.lastName,
          residentialAddress: {
            street: contactInfo.street,
            line1: line1,
            line2: line2,
            city: contactInfo.city,
            state: contactInfo.state,
            zip: contactInfo.zip,
          },
        },
      },
    };
    let body = {};
    let url = '';
    if (type === 'Insured') {
      body = {
        context: {
          requestId: uuid.v1(),
          userId: 'Owner',
        },
        payload: {
          insuredId: contactInfo.id,
          policyId: this.policyId,
          updateInformation: update,
        },
      };
      url = 'policy-admin/update-insured-information';
    }
    if (type === 'Owner') {
      body = {
        context: {
          requestId: uuid.v1(),
          userId: 'Owner',
        },
        payload: {
          ownerId: contactInfo.id,
          policyId: this.policyId,
          updateInformation: update,
        },
      };
      url = 'policy-admin/update-owner-information';
    }

    const subscription = await this.submitUpdateContact(url, body);
    return subscription.pipe(map((res) => {}));
  }

  getContactInfo(): ContactInfo {
    const owner = this.contactInfo.policy.owner;
    this.insuredId = this.contactInfo.policy.insured.insuredId;
    const ownerAddress = owner.contactInfo.residentialAddress;
    const type = this.contactInfo.policy.insured.party ? 'Owner' : 'Owner/Insured';
    const contactInfoOwner = new ContactInfo(
      owner.party.firstName,
      owner.party.lastName,
      ownerAddress.street,
      ownerAddress.line1,
      ownerAddress.line2,
      ownerAddress.city,
      ownerAddress.state,
      ownerAddress.zip,
      owner.contactInfo.phone.number,
      owner.ownerId,
      type
    );
    this.owner = contactInfoOwner;
    return contactInfoOwner;
  }

  getContactInfoInsured(): ContactInfo {
    if (this.contactInfo.policy.insured.party) {
      const insured = this.contactInfo.policy.insured;
      const insuredAddress = insured.contactInfo.residentialAddress;
      const contactInfoOwner = new ContactInfo(
        insured.party.firstName,
        insured.party.lastName,
        insuredAddress.street,
        insuredAddress.line1,
        insuredAddress.line2,
        insuredAddress.city,
        insuredAddress.state,
        insuredAddress.zip,
        insured.contactInfo.phone.number,
        insured.insuredId,
        'Insured'
      );
      this.insured = contactInfoOwner;
      return contactInfoOwner;
    }
    return null;
  }

  getLocation(zip: string) {
    return this.controller.publicGetLocationByZip(zip);
  }
}
